<template>
    <stepper-layout
        :stepTitle="'Payment Success!'"
        :stepIcon="'check_circle'"
        :class="darkMode ? '' : 'pl-1 pt-1'"
    >
        <payment-info
            :currentStep="currentStep"
            :payload="payload"
            :ccInfo="ccInfo"
            :cart="cart"
            :convenienceFees="convenienceFees"
        />
        <v-layout
          column
          class="subheading mt-5 mb-3 mx-4"
        >
            This payment has been processed successfully. You may select "Dismiss" to
            return to the application, or "Disposition" if the call has completed and you
            are ready to disposition.
        </v-layout>
    </stepper-layout>
</template>

<script>
import PaymentInfo from "../partials/PaymentInfo";
import StepperLayout from "@/layouts/StepperLayout";
import { mapState } from "vuex";

export default {
  props: {
    currentStep: {
      type: Number
    },
    payload: {
      type: Object
    },
    ccInfo: {
      type: Object
    },
    cart: {
      type: Array
    },
    convenienceFees: {
      type: [String, Object, Array]
    }
  },
  computed: {
    ...mapState({
      darkMode: state => state.application.settings.darkTheme
    })
  },
  components: { PaymentInfo, StepperLayout }
};
</script>

<style scoped>

</style>
